import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Anulicense } from '../license'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [screenScroller, setScreenScroller] = useState(0);
  const location = useLocation();

  const handleScroll = () => {
    const scrollTop = window.scrollY || window.pageYOffset;
    setScreenScroller(scrollTop);
  };

  useEffect(() => {
   window.addEventListener('scroll', handleScroll);
  });

  function handleSmoothScroll(){
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setIsMenuOpen(false)
  }

  // Function to check if link is active
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  // Function to get link classes with active state
  const getLinkClasses = (path) => {
    const baseClasses = "nav-link transition-colors duration-200";
    const activeClasses = "text-yellow-400 font-semibold";
    const inactiveClasses = "text-white hover:text-yellow-200";
    
    return `${baseClasses} ${isActiveLink(path) ? activeClasses : inactiveClasses}`;
  };

  // Function to get mobile link classes with active state
  const getMobileLinkClasses = (path) => {
    const baseClasses = "nav-link block py-2 transition-colors duration-200";
    const activeClasses = "text-black font-semibold bg-secondary px-3 rounded";
    const inactiveClasses = "text-white hover:text-yellow-200 px-3";
    
    return `${baseClasses} ${isActiveLink(path) ? activeClasses : inactiveClasses}`;
  };

  return (
    <nav className={`anuNavBar bg-[#f4f6f4] ${screenScroller > 100 ? 'fixed-navbar' : 'pb-2'}`}>
      <div className="container mx-auto">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center w-[200px] h-[150px]" onClick={()=>handleSmoothScroll()}>
            <img src={Anulicense.logo} alt="Alpha A Prints" className="h-full w-full object-contain" loading='..loading' />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center justify-center w-[100%] space-x-8">
            <Link to="/" className={getLinkClasses('/')} onClick={()=>handleSmoothScroll()}>
              Home
            </Link>
            <Link to="/services" className={getLinkClasses('/services')} onClick={()=>handleSmoothScroll()}>
              Services
            </Link>
            <Link to="/aboutUs" className={getLinkClasses('/aboutUs')} onClick={()=>handleSmoothScroll()}>
              About Us
            </Link>
            <Link to="/contact" className={getLinkClasses('/contact')} onClick={()=>handleSmoothScroll()}>
              Contact
            </Link>
            <Link to="/blog" className={getLinkClasses('/blog')} onClick={()=>handleSmoothScroll()}>
              Blog
            </Link>
          </div>
          
          {/* <div className="hidden md:flex items-center space-x-8">
            <Link to="/contact"  className="inline-flex items-center gap-2 text-[12px] uppercase p-4 bg-yellow-200 hover:bg-yellow-300 font-medium font-global_font rounded-sm transition-colors duration-200">
              Get a Quote 
              <span>
                <AiOutlineArrowRight className="text-[18px] font-medium"/>
              </span>
            </Link>
          </div> */}

          <button
            className="md:hidden text-primary"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="h-6 w-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link to="/" className={getMobileLinkClasses('/')} onClick={()=>handleSmoothScroll()}>
                Home
              </Link>
              <Link to="/services" className={getMobileLinkClasses('/services')} onClick={()=>handleSmoothScroll()}>
                Services
              </Link>
              <Link to="/aboutUs" className={getMobileLinkClasses('/aboutUs')} onClick={()=>handleSmoothScroll()}>
                About Us
              </Link>
              <Link to="/contact" className={getMobileLinkClasses('/contact')} onClick={()=>handleSmoothScroll()}>
                Contact
              </Link>
              <Link to="/blog" className={getMobileLinkClasses('/blog')} onClick={()=>handleSmoothScroll()}>
                Blog
              </Link>
              {/* <Link to="/contact"  className="btn btn-primary block text-center mt-4 bg-yellow-200 hover:bg-yellow-300 text-black p-3 rounded transition-colors duration-200">
                Get a Quote
              </Link> */}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;